module.exports = __webpack_public_path__ + "img/d811cf9cdb7f44bea885dba9a9e22139.2ea5b6ee.png";